import React from 'react';
import { StyledLoadCompleteMainProduct } from './styles';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { ProductData } from 'utils/types';

export type ILoadCompleteMainProductProps = {
  product: ProductData;
};

export const LoadCompleteMainProduct: React.FC<
  ILoadCompleteMainProductProps
> = ({ product }) => (
  <StyledLoadCompleteMainProduct
    className={'main-product'}
    textColor={product.textFontColorHex}
  >
    <div className="image-container">
      <img src={product.images.product} alt="product" className="image" />
    </div>
    <span className="quantity">
      <AutoTextSize maxFontSizePx={32} minFontSizePx={6} mode="oneline">
        {product.quantityDisplay}
      </AutoTextSize>
    </span>

    {product.strokedSaleQuantity && (
      <AutoTextSize
        as="div"
        mode="oneline"
        maxFontSizePx={18}
        minFontSizePx={6}
        className="quantity__stroked"
      >
        {product.strokedSaleQuantity}
      </AutoTextSize>
    )}
  </StyledLoadCompleteMainProduct>
);
